import { reportAction } from '#pplx/frontend/metrics/browser.js';
import { streamEvents } from '#pplx/frontend/stream/events.js';
import { useLayoutEffect } from 'react';
const STREAM_REPORT_PREFIX = 'ppl.web.frontend.stream';
function getConnectionType(isReconnect) {
    return isReconnect ? 'reconnect' : 'connect';
}
function getStreamReportActionName({ isReconnect, status, }) {
    return `${STREAM_REPORT_PREFIX}.${getConnectionType(isReconnect)}.${status}`;
}
function getErrorCode(error) {
    if (!(error instanceof Error)) {
        return 'unknown';
    }
    const { code, cause } = error;
    if (typeof code === 'string') {
        return code;
    }
    return getErrorCode(cause);
}
function getCauseErrorCode(error) {
    const { cause } = error;
    if (!cause) {
        return undefined;
    }
    const causeErrorCode = getErrorCode(cause);
    return causeErrorCode === 'unknown' ? undefined : causeErrorCode;
}
export function useReport() {
    useLayoutEffect(() => {
        const onCreatedUnsubscribe = streamEvents.on('created', ({ stream }) => {
            reportAction(getStreamReportActionName({
                isReconnect: stream.isReconnect,
                status: 'started',
            }));
        });
        const onErrorUnsubscribe = streamEvents.on('error', ({ stream, error, message }) => {
            reportAction(getStreamReportActionName({
                isReconnect: stream.isReconnect,
                status: 'failed',
            }), {
                error_code: getErrorCode(error),
                cause_error_code: getCauseErrorCode(error),
                error_name: error.name,
                has_entry_id: Boolean(stream.entryId),
                has_thread_id: Boolean(stream.threadId),
                has_message: Boolean(message),
            });
        });
        const onDisconnectedUnsubscribe = streamEvents.on('disconnected', ({ stream, error, message }) => {
            reportAction(getStreamReportActionName({
                isReconnect: stream.isReconnect,
                status: 'disconnected',
            }), {
                error_code: getErrorCode(error),
                cause_error_code: getCauseErrorCode(error),
                error_name: error.name,
                has_entry_id: Boolean(stream.entryId),
                has_thread_id: Boolean(stream.threadId),
                has_message: Boolean(message),
            });
        });
        return () => {
            onCreatedUnsubscribe();
            onErrorUnsubscribe();
            onDisconnectedUnsubscribe();
        };
    }, []);
}
//# sourceMappingURL=useReport.js.map